export default __webpack_public_path__ + "static/Litepaper - Polish-1bf5278c4b0645b55e3cf724ec47e622.pdf";